import {Injectable} from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {OwnerResponse} from '../models/owner-response.model';
import {Owner} from '../models/owner.model';

@Injectable({providedIn: 'root'})
export class VehicleOwnersResponseMapper extends Mapper<OwnerResponse, Owner> {
  override map(source: OwnerResponse): Owner {
    return new Owner(
      source.id,
      source.name
    )
  }
}
